export default __webpack_public_path__ + "static/media/FK.e1d78645.svg";